<template>
  <aside class="sidebar-profile">
    <!-- Desktop View -->
    <v-list v-if="!$vuetify.breakpoint.smAndDown" dense nav class="py-2">
      <div class="section">
        <div class="section-head">
          <v-icon class="head-icon">mdi-account-circle</v-icon>
          <span class="head-text">บัญชีของฉัน</span>
        </div>

        <v-list-item v-for="it in section1" :key="it.name" :class="['link-item', { active: isActive(it.name) }]"
          @click="go(it.name)">
          <v-list-item-content>
            <v-list-item-title class="link-text">{{
              it.label
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>

      <div class="section mt-6">
        <div class="section-head">
          <v-icon class="head-icon">mdi-chart-line</v-icon>
          <span class="head-text">การซื้อของฉัน</span>
        </div>

        <v-list-item v-for="it in section2" :key="it.name" :class="['link-item', { active: isActive(it.name) }]"
          @click="go(it)">
          <v-list-item-content>
            <v-list-item-title class="link-text">{{
              it.label
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>

    <!-- Mobile View -->
    <div v-else class="mobile-sidebar-wrapper">
      <v-select
        :value="current"
        :items="allMenuItems"
        item-text="label"
        item-value="name"
        outlined
        hide-details
        dense
        color="#F4811F"
        class="mobile-menu-select"
        :menu-props="{ contentClass: 'profile-mobile-dropdown' }"
        @change="go"
      >
        <template v-slot:prepend-inner>
          <v-icon color="#F4811F" size="18" class="mr-1 mt-1">mdi-menu</v-icon>
        </template>
        <template v-slot:append>
          <v-icon color="#F4811F" size="20" class="mt-1">mdi-chevron-down</v-icon>
        </template>
        <template v-slot:selection="{ item }">
          <span class="mobile-menu-selected">{{ item.label }}</span>
        </template>
        <template v-slot:item="{ item, on, attrs }">
          <v-divider v-if="item.divider" style="margin: 4px 0" />
          <v-subheader v-else-if="item.header" style="padding: 0 20px; font-size: 11px; font-weight: 700; color: #9ca3af; letter-spacing: 0.04em; height: 32px; font-family: 'Noto Sans Thai', sans-serif;">
            {{ item.header }}
          </v-subheader>
          <v-list-item v-else v-bind="attrs" v-on="on" style="padding: 0 20px" :class="{ 'mobile-menu-active-item': isActive(item.name) }">
            <v-list-item-content>
              <v-list-item-title :class="isActive(item.name) ? 'mobile-menu-item-active' : 'mobile-menu-item'">
                {{ item.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
    </div>
  </aside>
</template>

<script>
export default {
  name: "SidebarProfile",
  props: {
    current: { type: String, default: "" },
  },
  data() {
    return {
      section1: [
        { name: "profile_info", label: "ข้อมูลส่วนตัว" },
        { name: "profile_password", label: "เปลี่ยนรหัสผ่าน" },
        { name: "profile_address", label: "ที่อยู่" },
        { name: "profile_privacy", label: "การตั้งค่าความเป็นส่วนตัว" },
        // { name: "profile_notify", label: "ตั้งค่าการแจ้งเตือน" },
      ],
      section2: [
        { name: "orders_tracking", label: "ติดตามคำสั่งซื้อ" },
        { name: "orders_favorites", label: "บันทึกรายการโปรด" },
        { name: "wallet_coins", label: "Coins ของฉัน" },
        { name: "orders_history", label: "ประวัติการซื้อ" },
        { name: "orders_returns", label: "ยกเลิกสินค้า/คืนเงิน" },
        { name: "tickets", label: "แจ้งปัญหา / Ticket" },
        { name: "travel_history", label: "ประวัติการเรียกรถ" },
      ],
    };
  },
  computed: {
    allMenuItems() {
      return [
        { header: "บัญชีของฉัน" },
        ...this.section1,
        { divider: true },
        { header: "การซื้อของฉัน" },
        ...this.section2,
      ];
    }
  },
  methods: {
    isActive(name) {
      return this.current === name;
    },
    go(item) {
      const name = typeof item === "string" ? item : item?.name;
      if (!name) return;
      if (item?.route) {
        this.$router.push(item.route);
        return;
      }
      this.$emit("change", name);
    },
  },
};
</script>

<style scoped>
.sidebar-profile {
  width: 100%;
  min-width: 0;
}

.section {
  margin-bottom: 16px;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0 10px;
}

.head-icon {
  color: #F4811F;
  background: #fff2f1;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  font-size: 18px;
}

.head-text {
  font-weight: 700 !important;
  color: #111827 !important;
  font-size: 16px !important;
  line-height: 1.4 !important;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.link-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin: 2px 0;
  transition: background 0.15s ease, color 0.15s ease;
}

.link-item.active {
  background: #fff2f1;
  border-left: 3px solid #F4811F;
}

.link-text {
  font-size: 14px !important;
  color: #111827 !important;
  font-family: "Noto Sans Thai", sans-serif !important;
  padding: 5px 0px;
  padding-left: 8px;
  line-height: 1.6;
}

/* ฟอนต์พื้นฐานใน v-list-item */
:deep(.v-list-item__title),
:deep(.v-list-item__content),
:deep(.v-list-item__subtitle),
:deep(.v-list-item__action-text) {
  font-size: 14px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
}

:deep(.v-list-item) {
  min-height: 45px;
  height: auto !important;
  padding: 0 !important;
  align-items: center;
}

/* Mobile dropdown styles */
.mobile-sidebar-wrapper {
  width: 100%;
}

.mobile-menu-select {
  background: #fff;
  border-radius: 10px !important;
}

:deep(.mobile-menu-select .v-input__slot) {
  border-radius: 10px !important;
  min-height: 46px !important;
  padding: 0 10px !important;
  border-color: #e5e7eb !important;
}

:deep(.mobile-menu-select .v-input__append-inner) {
  margin-top: 0 !important;
  align-self: center;
}

:deep(.mobile-menu-select .v-input__prepend-inner) {
  margin-top: 0 !important;
  align-self: center;
}

.mobile-menu-selected {
  font-weight: 700;
  font-size: 14px;
  color: #F4811F;
  font-family: "Noto Sans Thai", sans-serif;
}

.mobile-menu-item {
  font-size: 14px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
  color: #111827 !important;
  font-weight: 500;
}

.mobile-menu-item-active {
  font-size: 14px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
  color: #F4811F !important;
  font-weight: 700;
}

.mobile-menu-active-item {
  background: #fff7f0 !important;
}

</style>

<style>
.profile-mobile-dropdown .v-list-item {
  padding: 0 20px !important;
}

.profile-mobile-dropdown .v-subheader {
  padding: 0 20px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #9ca3af !important;
  font-family: "Noto Sans Thai", sans-serif !important;
  height: 30px !important;
}
</style>
